module.exports = __webpack_public_path__ + "static/media/premium-mockups-modal.19044be8.png";